export default __webpack_public_path__ + "static/media/cyber_thum01.d14c7e4a.jpg";